module.exports = __webpack_public_path__ + "img/hyndai.737d8b11.png";